export default __webpack_public_path__ + "static/media/homepage.d8e79e77.png";